export const ErrorType = {
  SCROLLING_EXPIRED: 'SCROLLING_EXPIRED'
}
